/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostPlanChangeApprovalRequestApproveResponseData,
    PostPlanChangeApprovalRequestApproveResponseDataFromJSON,
    PostPlanChangeApprovalRequestApproveResponseDataFromJSONTyped,
    PostPlanChangeApprovalRequestApproveResponseDataToJSON,
} from './PostPlanChangeApprovalRequestApproveResponseData';

/**
 * 
 * @export
 * @interface PostPlanChangeApprovalRequestApproveResponse
 */
export interface PostPlanChangeApprovalRequestApproveResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PostPlanChangeApprovalRequestApproveResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof PostPlanChangeApprovalRequestApproveResponse
     */
    message: string;
    /**
     * 
     * @type {PostPlanChangeApprovalRequestApproveResponseData}
     * @memberof PostPlanChangeApprovalRequestApproveResponse
     */
    data: PostPlanChangeApprovalRequestApproveResponseData;
}

export function PostPlanChangeApprovalRequestApproveResponseFromJSON(json: any): PostPlanChangeApprovalRequestApproveResponse {
    return PostPlanChangeApprovalRequestApproveResponseFromJSONTyped(json, false);
}

export function PostPlanChangeApprovalRequestApproveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPlanChangeApprovalRequestApproveResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PostPlanChangeApprovalRequestApproveResponseDataFromJSON(json['data']),
    };
}

export function PostPlanChangeApprovalRequestApproveResponseToJSON(value?: PostPlanChangeApprovalRequestApproveResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PostPlanChangeApprovalRequestApproveResponseDataToJSON(value.data),
    };
}

